import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AnimalType} from "src/app/infrastructure/moovement-api/models/asset";

@Component({
  selector: 'app-animal-marker-svg',
  imports: [],
  templateUrl: './animal-marker-svg.component.html',
  styleUrl: './animal-marker-svg.component.css'
})
export class AnimalMarkerSvgComponent implements OnInit, OnChanges {

  @Input() hasWarning: boolean = false;
  @Input() animalType?: AnimalType;
  @Input() width: string = '20'
  @Input() height: string = '20'
  protected innerColor: string = '#FBA9D2';
  protected outerColor: string = '#A6708B';

  ngOnInit(): void {
    if (this.animalType) {
      this.setColor(this.animalType);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const currentValue = changes['animalType']?.currentValue as AnimalType;
    if (currentValue != undefined) {
      this.setColor(currentValue);
    }
  }

  private setColor(currentValue: AnimalType) {
    switch (currentValue) {
      case AnimalType.UNKNOWN: {
        this.innerColor = '#969696'
        this.outerColor = '#666666'
        // this.innerColor = '#00fff9'
        // this.outerColor = '#0056ff'
      }
        break
      case AnimalType.BULL: {
        this.innerColor = '#CEB2FC'
        this.outerColor = '#773BD8'
      }
        break
      case AnimalType.STEER: {
        this.innerColor = '#F3D9A8'
        this.outerColor = '#D68E02'
      }
        break
      case AnimalType.COW:
      case AnimalType.HEIFER: {
        this.innerColor = '#FBA9D2'
        this.outerColor = '#A6708B'
      }
        break
      case AnimalType.STEER_CALF:
      case AnimalType.STEER_WEANER:
      case AnimalType.BULL_CALF:
      case AnimalType.BULL_WEANER:
      case AnimalType.HEIFER_WEANER:
      case AnimalType.HEIFER_CALF: {
        this.innerColor = '#B9EEFF'
        this.outerColor = '#06B0E5'
      }
    }
  }
}
